import CopyIcon from "../../../assets/copyWhiteIcon.svg";
import DigitalMoneyIcon from "../../../assets/depositMoneyWhiteIcon.svg";
import digitalMoney from "../../../assets/digitalMoneyWhiteIcon.svg";
import MoneyTransfer from "../../../assets/moneyTransfer.svg";
import PixGreenIcon from "../../../assets/pixGreenIcon.svg";
import StarIcon from "../../../assets/starWhiteIcon.svg";
import "./../style.css";

import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "src/hooks/auth";

const iconButtons = [
	{
		icon: MoneyTransfer,
		text: "Transferir",
		link: "/pix/pix-and-transfers",
	},
	{
		icon: StarIcon,
		text: "Favoritos",
		link: "/pix/favorites",
	},
	{
		icon: CopyIcon,
		text: "Pix Copia e Cola",
		link: "/pix/copy-and-paste",
	},
	{
		icon: digitalMoney,
		text: "Cobrar",
		link: "/pix/new-qrcode",
	},
	{
		icon: DigitalMoneyIcon,
		text: "Depositar",
		link: "/wallet/adds-founds-wallet",
	},
];

export function PixArea() {
	const { account, user } = useAuth();
	const navigate = useNavigate();
	return (
		<div className="balance-card-pix border-radius-container flex flex-col bg-[#FBFAFA] border border-[#818181] shadow-md ">
			<div className="flex self-start items-center justify-center gap-header-pix">
				<img src={PixGreenIcon} className="pix-icon" alt="pix icon" />
				<h5 className="title-text">Área Pix</h5>
				<p className="text-[#718EBF] p-texte">Envie e receba pagamentos!</p>
			</div>
			<div className="flex flex-1 items-center justify-center gap-button-icons-pix ">
				{iconButtons.map((iconButton, index) => (
					<Link
						key={index}
						to={iconButton.link}
						className="transition hover:brightness-50 flex flex-col items-center gap-[10px]"
					>
						<button
							type="button"
							className="transition hover:brightness-50 flex flex-col items-center gap-icons-pix"
						>
							<div className="flex items-center justify-center rounded-full bg-[#1e1e1e] wrapper-icons-pix">
								<img src={iconButton.icon} className="icons-pix" alt="" />
							</div>
							<span className="text-[#718EBF] label-icon-pix">
								{iconButton.text}
							</span>
						</button>
					</Link>
				))}
			</div>
		</div>
	);
}
